import React from 'react';
import { Badge } from 'react-bootstrap';
import { CollectionOrderStates } from 'shared-pages/common/constants';

export const CollectionOrdersStatusesBadge = ({
  value,
  name,
}: {
  value?: number;
  name?: string;
}) => {
  const resolvedValue = value ?? CollectionOrderStates.NotRouted;

  const variant =
    resolvedValue === CollectionOrderStates.NotRouted
      ? 'warning'
      : resolvedValue === CollectionOrderStates.Routed
      ? 'primary'
      : resolvedValue === CollectionOrderStates.Executed
      ? 'success'
      : 'secondary';

  return (
    <Badge bg={variant} pill className="status-row-badge">
      {name ?? '---'}
    </Badge>
  );
};
